import React, { useState } from "react";
import { motion } from "framer-motion";
import {
    FaBars,
    FaTimes,
    FaFacebook,
    FaWhatsapp,
    FaLinkedin,
} from "react-icons/fa";
import icon from "../assets/images/icon.png";

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <header className="fixed w-full z-50">
            {/* Top Blue Bar */}
            <div className="bg-[#1e3a8a] text-white py-2">
                <div className="container mx-auto px-4 flex justify-between items-center">
                    <p className="text-xs md:text-sm">
                        The smarter way to manage your assets
                    </p>
                    <div className="flex items-center gap-2 md:gap-6">
                        <div className="hidden md:block text-sm">
                            Contact Us : +94 76 649 6256
                        </div>
                        <div className="flex items-center gap-2 md:gap-4">
                            <span className="text-sm hidden md:inline">
                                Follow Us on :
                            </span>
                            <div className="flex gap-3">
                                <a
                                    href="https://www.facebook.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="hover:text-[#FFD700] transition-colors text-sm md:text-base"
                                >
                                    <FaFacebook />
                                </a>
                                <a
                                    href="https://wa.me/94766496256"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="hover:text-[#FFD700] transition-colors text-sm md:text-base"
                                >
                                    <FaWhatsapp />
                                </a>
                                <a
                                    href="https://www.linkedin.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="hover:text-[#FFD700] transition-colors text-sm md:text-base"
                                >
                                    <FaLinkedin />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Navigation Bar */}
            <nav className="bg-white border-b">
                <div className="container mx-auto">
                    <div className="flex justify-between items-center h-20 px-4 md:px-8 lg:px-5">
                        {/* Logo Section */}
                        <div className="flex items-center">
                            <img
                                src={icon}
                                alt="Golden Eagle icon"
                                className="w-20 h-14 mr-3"
                                width={40}
                                height={40}
                                loading="eager"
                                decoding="async"
                                fetchpriority="high"
                            />
                            {/* Logo text section */}
                            <a href="#hero" className="flex flex-col">
                                <div className="flex h-8 md:h-10 border-2 border-black">
                                    {/* Black section with GOLDEN text */}
                                    <div className="bg-black h-full flex items-center justify-center px-4">
                                        <span className="text-[#FFD700] font-bold text-sm md:text-base">
                                            GOLDEN
                                        </span>
                                    </div>
                                    {/* Yellow section with EAGLE text */}
                                    <div className="bg-[#FFD700] h-full flex items-center justify-center px-3">
                                        <span className="text-black font-bold text-sm md:text-base">
                                            EAGLE
                                        </span>
                                    </div>
                                </div>
                                <span className="text-black text-[10px] md:text-xs font-semibold text-center tracking-wider mt-0.5">
                                    MANAGEMENT SOLUTIONS
                                </span>
                            </a>
                        </div>

                        {/* Desktop Navigation */}
                        <div className="hidden md:flex items-center space-x-8">
                            <a
                                href="#hero"
                                className="text-gray-800 hover:text-[#FFD700] transition-colors"
                            >
                                Home
                            </a>
                            <a
                                href="#services"
                                className="text-gray-800 hover:text-[#FFD700] transition-colors"
                            >
                                Our Service
                            </a>
                            <a
                                href="#about"
                                className="text-gray-800 hover:text-[#FFD700] transition-colors"
                            >
                                About Us
                            </a>
                            <a
                                href="#contact"
                                className="text-gray-800 hover:text-[#FFD700] transition-colors"
                            >
                                Contact Us
                            </a>
                        </div>

                        {/* Mobile menu button */}
                        <button
                            className="md:hidden text-gray-600"
                            onClick={() => setIsOpen(!isOpen)}
                        >
                            {isOpen ? (
                                <FaTimes size={24} />
                            ) : (
                                <FaBars size={24} />
                            )}
                        </button>
                    </div>

                    {/* Mobile Navigation */}
                    <motion.div
                        initial={{ height: 0 }}
                        animate={{ height: isOpen ? "auto" : 0 }}
                        transition={{ duration: 0.3 }}
                        className="md:hidden overflow-hidden bg-white"
                    >
                        <div className="px-4 py-2 space-y-4">
                            <a
                                href="#hero"
                                className="block py-2 text-gray-800 hover:text-[#FFD700] transition-colors"
                                onClick={() => setIsOpen(false)}
                            >
                                Home
                            </a>
                            <a
                                href="#services"
                                className="block py-2 text-gray-800 hover:text-[#FFD700] transition-colors"
                                onClick={() => setIsOpen(false)}
                            >
                                Our Service
                            </a>
                            <a
                                href="#about"
                                className="block py-2 text-gray-800 hover:text-[#FFD700] transition-colors"
                                onClick={() => setIsOpen(false)}
                            >
                                About Us
                            </a>
                            <a
                                href="#contact"
                                className="block py-2 text-gray-800 hover:text-[#FFD700] transition-colors"
                                onClick={() => setIsOpen(false)}
                            >
                                Contact Us
                            </a>
                        </div>
                    </motion.div>
                </div>
            </nav>
        </header>
    );
};

export default Navbar;
